import './App.scss';
import '../i18n';

export default function App() {
    return <h1>Disabled</h1>;
}
